import { withProps, compose } from 'recompose';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';

export default () =>
  compose(
    withWidth(),
    withProps(({ width }) => ({ isMobile: isWidthDown('sm', width) })),
  );
